import { render } from "./GroupwiseSalaryPovisionAllocation.vue?vue&type=template&id=efb17962"
import script from "./GroupwiseSalaryPovisionAllocation.vue?vue&type=script&lang=js"
export * from "./GroupwiseSalaryPovisionAllocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__